import { render, staticRenderFns } from "./ListSueldos.vue?vue&type=template&id=30b88616&"
import script from "./ListSueldos.vue?vue&type=script&lang=js&"
export * from "./ListSueldos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports